import React from 'react';
import { Link } from 'react-router-dom';

const ButtonTwo = (props) => {
  const { btnClass, btnURL, btnText } = props;
  return (
    <Link
      to={btnURL ? btnURL : '/contact'}
      className={btnClass ? btnClass : 'it-btn-theme red-bg d-none d-lg-block'}
    >
      <span className="btn-wrap">
        <span className="text-one">
          {btnText ? btnText : 'Get in Touch'}
          <i>
            <svg
              width="34"
              height="12"
              viewBox="0 0 34 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4512 6.67971H0.683183C0.305297 6.67971 0 6.37442 0 5.99653C0 5.61865 0.305297 5.31335 0.683183 5.31335H30.8009L26.6548 1.16728C26.3879 0.900413 26.3879 0.46702 26.6548 0.200151C26.9217 -0.0667171 27.3551 -0.0667171 27.6219 0.200151L32.9358 5.51403C33.1322 5.71045 33.1899 6.00294 33.0831 6.25913C32.9764 6.51319 32.7266 6.67971 32.4512 6.67971Z"
                fill="currentcolor"
              />
              <path
                d="M27.1309 12C26.9558 12 26.7808 11.9338 26.6484 11.7993C26.3815 11.5325 26.3815 11.0991 26.6484 10.8322L31.9687 5.51192C32.2355 5.24505 32.6689 5.24505 32.9358 5.51192C33.2027 5.77879 33.2027 6.21218 32.9358 6.47905L27.6155 11.7993C27.481 11.9338 27.306 12 27.1309 12Z"
                fill="currentcolor"
              />
            </svg>
          </i>
        </span>
        <span className="text-two">
          {btnText ? btnText : 'Get in Touch'}
          <i>
            <svg
              width="34"
              height="12"
              viewBox="0 0 34 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.4512 6.67971H0.683183C0.305297 6.67971 0 6.37442 0 5.99653C0 5.61865 0.305297 5.31335 0.683183 5.31335H30.8009L26.6548 1.16728C26.3879 0.900413 26.3879 0.46702 26.6548 0.200151C26.9217 -0.0667171 27.3551 -0.0667171 27.6219 0.200151L32.9358 5.51403C33.1322 5.71045 33.1899 6.00294 33.0831 6.25913C32.9764 6.51319 32.7266 6.67971 32.4512 6.67971Z"
                fill="currentcolor"
              />
              <path
                d="M27.1309 12C26.9558 12 26.7808 11.9338 26.6484 11.7993C26.3815 11.5325 26.3815 11.0991 26.6484 10.8322L31.9687 5.51192C32.2355 5.24505 32.6689 5.24505 32.9358 5.51192C33.2027 5.77879 33.2027 6.21218 32.9358 6.47905L27.6155 11.7993C27.481 11.9338 27.306 12 27.1309 12Z"
                fill="currentcolor"
              />
            </svg>
          </i>
        </span>
      </span>
    </Link>
  );
};

export default ButtonTwo;
